var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSparklesPink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 33,
    viewBox: "0 0 34 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4362_17415",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 33
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.920898,
    y: 0.577148,
    width: 32.3077,
    height: 32.3077,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4362_17415)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.8245 12.1538L24.411 8.99038L21.2476 7.57692L24.411 6.12981L25.8245 3L27.2379 6.12981L30.4014 7.57692L27.2379 8.99038L25.8245 12.1538ZM25.8245 30.4615L24.411 27.3317L21.2476 25.8846L24.411 24.4711L25.8245 21.3077L27.2379 24.4711L30.4014 25.8846L27.2379 27.3317L25.8245 30.4615ZM12.8677 25.8846L10.0408 19.5913L3.74756 16.7308L10.0408 13.8702L12.8677 7.57692L15.7283 13.8702L22.0216 16.7308L15.7283 19.5913L12.8677 25.8846Z",
    fill: "#F2A9C3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSparklesPink);
export default __webpack_public_path__ + "static/media/sparkles-pink.9739f34dd67df9c1b88bd1dcb1e08ef4.svg";
export { ForwardRef as ReactComponent };